import { styled } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";

export const StyledCustomAutocomplete = styled(Autocomplete)(({ theme }) => ({
  backgroundColor: "white",

  "& .MuiOutlinedInput-root": {
    "&.Mui-focused fieldset": {
      borderColor: "#041295",
    },
  },
}));
